import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tableHeadReorderLabel: {
		id: 'software-board-settings-sortable-table.sortable-table.reorder-header.table-head-reorder-label',
		defaultMessage: 'Reorder',
		description: 'Table header label for the Reorder column',
	},
});
